const gridEditorTypesMap = {
  form: 'form',
  editable_component: 'editable_component',
}

export default gridEditorTypesMap
